// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

//otro

import { Component, OnInit, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { CompanylinkedService } from '../../services/companylinked.service';
import { CompanyLinked } from '../../models/companylinked';
import swal from 'sweetalert2';
import { NuevoCompany} from '../listcompany/listcompany.component';
import { FolderService } from '../../services/folder.service';
import { Folder } from '../../models/folder';
import { DateAdapter } from '@angular/material/core';
import { TitleService } from '../../services/title.service';
import { Cell, DinamicData } from 'src/app/models/dinamic-data';
import { ConfigService } from '../../services/config.service';
import { Methods } from 'src/app/shared/methods';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
    selector: 'app-listlogs-cmp',
    templateUrl: 'listlogs.component.html',
    providers: [UserService, FolderService, CompanylinkedService]
})

export class ListlogsComponent implements OnInit, AfterViewInit {

  name: string;
  animal: string;

  public privilegio;
  sexos = [
      {value: '1', viewValue: 'Hombre'},
      {value: '0', viewValue: 'Mujer'}
    ];
   frequencies = [
     {value: 'DAILY', viewValue: 'Daily'},
      {value: 'WEEKLY', viewValue: 'Weekly'},
      {value: 'MONTHLY', viewValue: 'Monthly'},
       {value: 'NEVER', viewValue: 'Never'},
  ];
  /* public dataTable: DataTable; */
  public pacientes: Array<User>;
  public mtds: Methods = new Methods();
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public loading = false;
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public filter = 0;
  public order = 0;
  public searchString;
  public user;
  public status_user;
  public companySelected;
  public options: Array<any> = [];

  public dataTable: DinamicData = new DinamicData(
    ['ID','Company', 'Name','Role', 'Last Seen']
  )

  constructor(public dialog: MatDialog, private _route: ActivatedRoute,
    private titleService: Title,
    private _router: Router,
     private _folderService: FolderService,
     private _companylinkedService: CompanylinkedService,
    private _userService: UserService,
    private _config: ConfigService,
    private titleServices: TitleService) {
      this.titleService.setTitle( 'Logs' );
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  ngOnInit(){
    if(this.identity == null && this.identity.sub){
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {
      this._config.getConfig('LogsTable').subscribe(
        r => {
          if (r.data) {
            this.options = JSON.parse(r.data.data);
            this.itemsPorPagina = r.data.pageLimit;
          } else {
            this.options = this.mtds.colopt(this.dataTable.headers, []);
          }
          this.getAllLogs();
          /* this.loadDataAsync(); */
        }, error => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
    }
    this.titleServices.setTitle("Log's List");
  }

  pipeRep(rep) {
    switch (rep) {
      case 'SALESREP':
        return 'SALES REP';
      case 'TECHREP':
        return 'TECH REP';
      case 'ADMINISTRATOR':
        return 'ADMINISTRATOR';
      case 'CLERICALREP':
        return 'CLERICAL REP';
      case 'SHIPPINGREP':
        return 'SHIPPING REP';
      case 'PURCHASINGREP':
        return 'PURCHASING REP';
      case 'RECEIVINGDEPARTMENT':
        return 'RECEIVING DEPARTMENT';
      case 'MANIFESTDEPARTMENT':
        return 'MANIFEST DEPARTMENT';
      case 'MANAGER':
        return 'MANAGER';
      case 'DRIVER':
        return 'DRIVER';
      case 'TECHREP':
        return 'TECH REP';
      case 'WAREHOUSE SUPERVISOR':
        return 'WAREHOUSE SUPERVISOR';
      default:
        return rep;
    }
  }


  deleteUser(){
    let id = $( "#borrarUser" ).val();
    console.log(id + "aqui");
    this._userService.deleteUser(this.token, id).subscribe(
      response =>{
        if(response.status == 'success'){
          //this._router.navigate(['/']);
         // this.getAllPacientes();
         alert("Done");
        } else {
          alert("No se ha borrado el usuario");
        }
      },
      error => {
        console.log(<any>error);
      }
      );
  }

showSwal(type) {
       if (type === 'success-message') {
            swal.fire({
             
                title: 'Client Successfully Saved!',
                text: '',
                buttonsStyling: false,
            customClass:{
    confirmButton: 'btn btn-success'
            },


            });

        } else if (type === 'warning-message-and-confirmation') {
            swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to revert this!',
                  
                    showCancelButton: true,
                    
                    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },

                    confirmButtonText: 'Yes, delete it!',
                    buttonsStyling: false
                }).then(function() {
                  swal.fire({
                    title: 'Deleted!',
                    text: 'Your file has been deleted.',
                  
                    customClass:{
    confirmButton: 'btn btn-success'
            },

                    buttonsStyling: false
                });
                });
            } else if (type === 'warning-message-and-cancel') {
            swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this imaginary file!',
              
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, keep it',
                

                    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },


                    buttonsStyling: false
                }).then(function() {
                  swal.fire({
                    title: 'Deleted!',
                    text: 'Your imaginary file has been deleted.',
               
           
                    customClass:{
    confirmButton: 'btn btn-success'
            },

                    buttonsStyling: false
                });
                }, function(dismiss) {
                  // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                  if (dismiss === 'cancel') {
                    swal.fire({
                      title: 'Cancelled',
                      text: 'Your imaginary file is safe :)',
             
                      customClass:{
    confirmButton: 'btn btn-info'
            },

                      buttonsStyling: false
                  });
                  }
              });
          } else if (type === 'custom-html') {
            swal.fire({
                title: 'HTML example',
                buttonsStyling: false,
             
                  customClass:{
    confirmButton: 'btn btn-success'
            },
                html:
                        'You can use <b>bold text</b>, ' +
                        '<a href="http://github.com">links</a> ' +
                        'and other HTML tags'
                });

            } else if (type === 'auto-close') {
            swal.fire({  title: 'Auto close alert!',
                    text: 'I will close in 2 seconds.',
                    timer: 2000,
                    showConfirmButton: false
                }).then(
                    function () {},
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                            console.log('I was closed by the timer')
                        }
                });
            } else if (type === 'input-field') {
            swal.fire({
                    title: 'Input something',
                    html: '<div class="form-group">' +
                              '<input id="input-field" type="text" class="form-control" />' +
                          '</div>',
                    showCancelButton: true,
                   customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },

                    buttonsStyling: false
                }).then(function(result) {
                    swal.fire({
                  
                        html: 'You entered: <strong>' +
                                $('#input-field').val() +
                              '</strong>',
                     customClass:{
    confirmButton: 'btn btn-success'
            },

                        buttonsStyling: false

                    });
                });
        }
    }
    public filtros = [
      {
        key: "id",
        title: "ID",
        value: "",
        type: "contains",
        key_type: "id_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },

      {
        key: "company",
        title: "Company",
        value: "",
        type: "contains",
        key_type: "company_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "name",
        title: "name",
        value: "",
        type: "contains",
        key_type: "name_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "role",
        title: "Role",
        value: "",
        type: "contains",
        key_type: "role_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "lastseen",
        title: "Last Seen",
        value: "",
        type: "contains",
        key_type: "lastseen_type",
        type_options: [
          { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' } ,  { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
        ],
      },
    ];




    getAllLogs(e = null){
      this.loading = true;

      this._userService.getLogs(this.token,e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,this.filterrigh,this.sortStates,this.filtros). subscribe(
        response =>{
          if (response.status === 'success') {
          this.paginaActual = Number(response.page_actual);
          this.itemsPorPagina = String(response.items_per_page);
          this.totalItems = Number(response.total_items_count);
          this.totalPaginas = Number(response.total_pages);
          this.dataTable.rows = [];
          for (let element of response.data) {
            const date = new Date(element.lastActivity);
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            this.dataTable.rows.push(
              [ 
                new Cell(element.id ?? ''),
                new Cell(element.namecompany?? '' ),
                new Cell(`${element.name ?? ''} ${element.surname ?? ''}`.trim()), 
                new Cell(element.role ?? ''),
                new Cell(formattedDate ?? ''),
              ]
            );
          }
        }
        this.loading = false;
      },
      (error) => {
        this.mtds.notifyError(
          "Error " + error.status + ": " + error.statusText,
          error.status
        );
        this.loading = false;
      }
    );
  }


    public filterrigh = "";
    public sortStates = ""; 
    handleRightClick(data: any): void {
      const columnKey = data.columnName.key;
      if(columnKey === this.filterrigh ){
        if(this.sortStates === "DESC"){
          this.sortStates = "ASC"
        }else{
          this.sortStates = "DESC"
        }
      } else{
        this.sortStates = "ASC"
      }
      this.filterrigh = columnKey;
            
      this.getAllLogs();

    }

/*   getAllPacientes(){
    this._route.params.forEach((params: Params) => {
      let page =+ params['page'];

      if(!page){
        page = 1;
      }

      this.loading = 'show';
      this._userService.getAllUsersLite(this.token, "logs"). subscribe(
        response =>{
          console.log(response);
          if(response.status == 'success'){
            console.log(response.data);
            this.pacientes = response.data;
            console.log(this.pacientes);


this.dataTable = {
            headerRow: ['ID', 'Name', 'Role', 'Last Seen', 'Actions' ],
            footerRow: ['ID', 'Name', 'Role', 'Last Seen', 'Actions' ],

            dataRows: [

            ]
         };



            this.pacientes.forEach(function(element) {
             let nameCompany = "";
             let lastLogin;
             if(element.companyLinked != null)
                nameCompany = element.companyLinked.name;
                //lastLogin = element.lastActivity.timestamp | date: 'yyyy-MM-dd';
                
                if(element.lastActivity == null)
                  lastLogin = "-";
                else
                  lastLogin = element.lastActivity;
                //console.log(element.lastActivity.toGMTString());
              this.dataTable.dataRows.push([element.id,element.name + ' ' + element.surname, this.pipeRep(element.role), lastLogin, element.lastActivity, element.namecompany]);
            }.bind(this));

            this.loading = 'hide';

            //total paginas
            this.pages = [];
            for(let i = 0; i < response.total_pages; i++){
              this.pages.push(i);
            }

            //pagina anterior
            if(page >= 2){
              this.pagePrev = (page - 1);

            } else {
              this.pagePrev = page;
            }

            //pagina siguiente
            if(page < response.total_pages){
              this.pageNext = (page+1);
            } else {
              this.pageNext = page;
            }
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );
    });
  } */

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig('LogsTable', this.options).subscribe(
      r => {
        console.log(r)
/*         if (r.data) {
          this.config = JSON.parse(r.data.data);
        } else {
          this.config = this.mtds.colopt(
            this.vendorData.headers, [false]
          );
        }
        this.getOnlyVendor(); */
      }
    );
  }

deleteFolderfirst(folder){
    var txt;
    var r = confirm("Are you sure to delete this user?");
    if (r == true) {
        $("#user"+folder).hide();
         $( "#borrarUser" ).val(folder);

        $( "#borrarUser" ).trigger( "click" );
    } else {

    }
  }



    ngAfterViewInit() {
      $('#datatables').DataTable({
        dom: 'Bflrtip',
        columnDefs: [
          { targets: [3], type: 'date' }
        ],
        buttons: [
          /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*//*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
          {
            extend: 'excel',
            text: '<i class="fa fa-file-excel-o"></i>',
            titleAttr: 'Excel',
            className: 'btn btn-sm btn-outline-success',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'pdf',
            text: '<i class="fa fa-file-pdf-o"></i>',
            titleAttr: 'PDF',
            className: 'btn btn-sm btn-outline-danger',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'print',
            text: '<i class="fa fa-print" aria-hidden="true"></i>',
            titleAttr: 'print',
            className: 'btn btn-sm btn-outline-primary',
            exportOptions: {
              columns: ':visible'
            }
          }
        ],
        "pagingType": "full_numbers",
          "order": [[ 3, "desc" ]],
        "lengthMenu": [
          [10, 25, 50, -1],
          [10, 25, 50, "All"]
        ],
        responsive: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search records",
        }

      });

      const table = $('#datatables').DataTable();

      // Edit record
      table.on('click', '.edit', function() {
        console.log("entramos");
        const $tr = $(this).closest('tr');

        const data = table.row($tr).data();
        alert('You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.');
      });

      // Delete a record
      table.on('click', '.remove', function(e) {
         e.preventDefault();

          var txt;
    var r = confirm("Are you sure to delete this client?");
    if (r == true) {
        const $tr = $(this).closest('tr');
        const data = table.row($tr).data();

        table.row($tr).remove().draw();
         $( "#borrarUser" ).val(data[0]);

        $( "#borrarUser" ).trigger( "click" );
    } else {

    }


      });

      //Like record
      table.on('click', '.like', function() {
        console.log("like");

      });

      $('.card .material-datatables label').addClass('form-group');
    }
}